import { FC } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";

import ExportButton from "@/components/ExportButton";
import { OptimisationTestTypeEnum } from "@/utils/enums";
import { api } from "@/utils/api";
import { ExportGroup } from "@/components/CsvExportModal";

const StyledExportButton = styled(ExportButton)`
  height: 38px;
  padding: 0 10px 0 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
`;

const Wrap = styled.div`
  margin-right: 16px;
  margin-left: auto;
`;

const getTestTypeLabel = (type: OptimisationTestTypeEnum) => {
  switch (type) {
    case OptimisationTestTypeEnum.THUMBS:
      return "Thumbs";
    case OptimisationTestTypeEnum.TIPS:
      return "Tips";
    case OptimisationTestTypeEnum.SEQUENCES:
      return "Sequences";
    case OptimisationTestTypeEnum.FINALISATION:
      return "Finalisation";
    default:
      return "";
  }
};

interface Props {
  type: OptimisationTestTypeEnum;
  externalProjectId: string;
}

const GoogleAdsExportButton: FC<Props> = ({ type, externalProjectId }) => {
  const { id } = useParams();

  const exportOptions = [
    {
      fileName: `Testing-${externalProjectId}-${getTestTypeLabel(type)}.csv`,
      title: "Google Ads CSV",
      fetchCsv: () =>
        api.get<never, string>(`/v1/optimisation-tests/${id}/ga-csv`, {
          params: {
            type,
          },
        }),
    },
    {
      fileName: `${getTestTypeLabel(type)}-results.csv`,
      title: "Results CSV",
      modalOptions: {
        primaryTitle: getTestTypeLabel(type),
        secondaryTitle: "Export Results CSV",
        exportGroup: ExportGroup.YOUTUBE_TEST_RESULTS,
        onExport: (cols: string[]) =>
          api.get<never, string>(`/v1/optimisation-tests/${id}/export`, {
            params: {
              "filter[type]": type,
              cols: cols.join(","),
            },
          }),
      },
    },
  ];

  return (
    <Wrap>
      <StyledExportButton exportOptions={exportOptions} />
    </Wrap>
  );
};

export default GoogleAdsExportButton;
